$(document).ready(function() {
  if($('#product-gallery-mobile .gallery__strip').length) {
    $('#product-gallery-mobile .gallery__strip').slick({
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      arrows: true,
      nextArrow: $('button.gallery-indicator__arrow.gallery-indicator__arrow--next'),
      prevArrow: $('button.gallery-indicator__arrow.gallery-indicator__arrow--previous')
    });

    $('#product-gallery-main .product-gallery-main-slider').slick({
      dots: false,
      infinite: false,
      arrows:false,
      speed: 500,
      slidesToShow: 1,
      asNavFor:'#product-gallery-main .thumbnails .gallery__strip',
      adaptiveHeight: true,
      vertical: true,
      verticalSwiping: true
    });
    $('#product-gallery-main .thumbnails .gallery__strip').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '#product-gallery-main .product-gallery-main-slider',
      dots: false,
      focusOnSelect: true,
      arrows:true,
      vertical: true,
      verticalSwiping: true,
      infinite: false,
      prevArrow:'<button class="thumb-button_prev custom-thumb-arrows"><img src="https://cdn.shopify.com/s/files/1/0246/7178/0939/files/up-arrow_1.png?v=1643882887" alt="arrow"/></button>',
      nextArrow:'<button class="thumb-button_next custom-thumb-arrows"><img src="https://cdn.shopify.com/s/files/1/0246/7178/0939/files/up-arrow_2.png?v=1643882887" alt="arrow"/></button>'
    });
  }

  $(window).on("resize", function () {
    if($(this).width() > 989) {
      $('#product-gallery-slider .ctm-gallery__strip').slick({
        dots: false,
        infinite: false,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        asNavFor: '#product-gallery-slider .thumbnails .gallery__strip',
        adaptiveHeight: true,
        vertical: true,
        verticalSwiping: true
      });
      $('#product-gallery-slider .thumbnails .gallery__strip').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '#product-gallery-slider .ctm-gallery__strip',
        dots: false,
        focusOnSelect: true,
        arrows:true,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        infinite: false,
        prevArrow:'<button class="thumb-button_prev custom-thumb-arrows"><img src="https://cdn.shopify.com/s/files/1/0246/7178/0939/files/up-arrow_1.png?v=1643882887" alt="arrow"/></button>',
        nextArrow:'<button class="thumb-button_next custom-thumb-arrows"><img src="https://cdn.shopify.com/s/files/1/0246/7178/0939/files/up-arrow_2.png?v=1643882887" alt="arrow"/></button>'
      });
    } else {
      $('#product-gallery-slider .ctm-gallery__strip').slick('unslick');
      $('#product-gallery-slider .thumbnails .gallery__strip').slick('unslick');
    }
  }).resize();
  
//   Fancybox.bind("[data-fancybox]", {
//     // Your options go here
//   });

});